export default __webpack_public_path__ + "static/media/team.e96f9b24.jpg";